"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var userSettings_1 = require("@/react-app/common/utils/userSettings");
var TablePagination_1 = __importDefault(require("./TablePagination"));
var utils_1 = require("./utils");
function CustomTable(_a) {
    var _b, _c;
    var data = _a.data, columns = _a.columns, limit = _a.limit, editHref = _a.editHref, handleDelete = _a.handleDelete, columnRenderer = _a.columnRenderer, entity = _a.entity, domain = _a.domain, currentUser = _a.currentUser, defaultTableSorting = _a.defaultTableSorting, page = _a.page, setPage = _a.setPage, handleEdit = _a.handleEdit, _d = _a.showEditAndDeleteIcons, showEditAndDeleteIcons = _d === void 0 ? function () { return true; } : _d, tableClassName = _a.tableClassName, deleteIconCy = _a.deleteIconCy, removeStrips = _a.removeStrips;
    var totalCount = data.length;
    var entitySortingLocalStorage = (_b = (0, userSettings_1.getUserSetting)("".concat(entity, "Sorting"), currentUser)) === null || _b === void 0 ? void 0 : _b[domain];
    var defaultOrderBy = (entitySortingLocalStorage ? (_c = Object.keys(entitySortingLocalStorage)) === null || _c === void 0 ? void 0 : _c[0] : Object.keys(defaultTableSorting)[0]);
    var defaultOrder = entitySortingLocalStorage
        ? entitySortingLocalStorage[defaultOrderBy]
        : defaultTableSorting[defaultOrderBy];
    var _e = __read(react_1.default.useState(defaultOrderBy), 2), orderBy = _e[0], setOrderBy = _e[1];
    var _f = __read(react_1.default.useState(defaultOrder || 'asc'), 2), order = _f[0], setOrder = _f[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var saveSortPerDomainInLocalStorage = function (orderBy, order) {
        var _a, _b;
        var entitySorting = (0, userSettings_1.getUserSetting)("".concat(entity, "Sorting"), currentUser);
        (0, userSettings_1.saveUserSetting)("".concat(entity, "Sorting"), __assign(__assign({}, entitySorting), (_a = {}, _a[domain] = (_b = {},
            _b[orderBy] = order,
            _b), _a)), currentUser);
    };
    var handleRequestSort = function (property) {
        var _a;
        // default column sorting
        if (orderBy !== property) {
            var newOrder_1 = ((_a = columns.find(function (item) { return item.property === property; })) === null || _a === void 0 ? void 0 : _a.defaultSort) || 'asc';
            setOrder(newOrder_1);
            setOrderBy(property);
            saveSortPerDomainInLocalStorage(property, newOrder_1);
            return;
        }
        // inverse column sorting
        var isAsc = orderBy === property && order === 'asc';
        var newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        saveSortPerDomainInLocalStorage(property, newOrder);
    };
    var renderSortIcon = function (property) {
        if (orderBy !== property)
            return null;
        return orderBy === property && order === 'asc' ? (react_1.default.createElement("i", { className: "implioicons-chevron-up" })) : (react_1.default.createElement("i", { className: "implioicons-chevron-down" }));
    };
    // set page to 1 if not provided
    var currentPage = page !== null && page !== void 0 ? page : 1;
    var pageFirstIndex = (currentPage - 1) * limit;
    var pageLastIndex = pageFirstIndex + limit;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "table-responsive table-container" },
            react_1.default.createElement("table", { className: (0, clsx_1.default)('table', !removeStrips && 'table-striped', tableClassName) },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        columns.map(function (item, columnIndex) {
                            return (react_1.default.createElement("th", { className: "cursor-pointer", onClick: function () { return handleRequestSort(item.property); }, key: columnIndex },
                                item.label,
                                " ",
                                renderSortIcon(item.property)));
                        }),
                        (editHref || handleEdit) && react_1.default.createElement("th", null),
                        handleDelete && react_1.default.createElement("th", null))),
                react_1.default.createElement("tbody", null, data
                    .sort((0, utils_1.getComparator)(order, orderBy))
                    .slice(pageFirstIndex, pageLastIndex)
                    .map(function (row, rowIndex) { return (react_1.default.createElement("tr", { key: rowIndex },
                    columns.map(function (column, columnIndex) { return columnRenderer(row, column.property, "".concat(rowIndex, "-").concat(columnIndex)); }),
                    (editHref || handleEdit) && (react_1.default.createElement("td", null, showEditAndDeleteIcons(row) && (react_1.default.createElement("a", { className: "edit-icon", href: editHref && editHref(row), title: t('AUTOMATION.DECISION_RULES.EDIT_TOOLTIP'), onClick: function () { return handleEdit && handleEdit(row); } })))),
                    handleDelete && (react_1.default.createElement("td", null, showEditAndDeleteIcons(row) && (react_1.default.createElement("a", { className: "delete-icon", title: t('AUTOMATION.DECISION_RULES.DELETE_TOOLTIP'), onClick: function () { return handleDelete(row); }, "data-cy": deleteIconCy })))))); })))),
        page && setPage && react_1.default.createElement(TablePagination_1.default, { totalCount: totalCount, limit: limit, page: page, setPage: setPage })));
}
exports.default = CustomTable;
